import { Button, Stack, Typography } from '@mui/material';
import { SlidingPanel } from '@side/pantry';
import type { ReactNode } from 'react';

interface Props {
  open: boolean;
  title: string;
  children: ReactNode;
  isSubmitDisabled: boolean;
  onClear: () => void;
  onClose: () => void;
  onSubmit: () => void;
  isClearDisabled: boolean;
}

export function ReportFiltersDrawer({
  open,
  onClose,
  onSubmit,
  onClear,
  title,
  children,
  isSubmitDisabled,
  isClearDisabled,
}: Props) {
  return (
    <SlidingPanel
      open={open}
      onClose={onClose}
      anchor="right"
      footerSlot={
        <Stack direction="column" sx={{ gap: 2 }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={onClear}
            disabled={isClearDisabled}
          >
            Reset Filters
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={isSubmitDisabled}
          >
            Save & Apply
          </Button>
        </Stack>
      }
    >
      <Stack direction="column" sx={{ gap: 1 }}>
        <Typography variant="overline" sx={{ color: 'text.secondary' }}>
          Filters
        </Typography>
        <Typography variant="h2" sx={{ mb: 3, color: 'text.secondary' }}>
          {title}
        </Typography>
        {children}
      </Stack>
    </SlidingPanel>
  );
}
